// ExportClientTrialsPDF.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';

import websitelogo from "../../../../assets/websitelogo.png";
import websitelogoes from "../../../../assets/websitelogoes.png";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#101828',
  },
  logo: {
    width: 120,
    marginBottom: 20,
    alignSelf: "center",
  },
  heading: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#003149',
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  label: {
    color: '#344054',
    fontWeight: 'bold',
  },
  value: {
    color: '#101828',
  },
});

const ExportClientTrialsPDF = ({ data }) => {
  const { t, i18n } = useTranslation();

  const logoToUse = i18n.language === "es" ? websitelogo : websitelogoes;
  const formatSubscription = (value) => {
  if (!value) return "";

  return value
    .replace(/_/g, " ")             // full_monthly → full monthly
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Full Monthly
};
  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* Dynamic logo */}
        <Image src={logoToUse} style={styles.logo} />

        {/* Dynamic heading */}
        <Text style={styles.heading}>  {t('clientsTrial.manageClients')}</Text>

        {data.map((item, index) => (
          <View key={index} style={styles.recordGroup}>
            
            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.id")}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.companyAdmin")}:</Text>
              <Text style={styles.value}>{item.admin}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.companyLegalName")}:</Text>
              <Text style={styles.value}>{item.company}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.country")}:</Text>
              <Text style={styles.value}>{item.country}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("ClientsRequests.columns.subscription")}:</Text>
              <Text style={styles.value}>{item.subscription ? formatSubscription(item.subscription) : '-'}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("InviteDetails.subscriptionStatus")}:</Text>
              <Text style={styles.value}>{item.subscriptionStatus}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.status")}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("clientsTrial.dateTime")}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>

          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportClientTrialsPDF;
